import { CalloutContentCollection, CalloutCollection } from '../../entities/callout-content.entity';
import {
  AishCallout_Assets_InformationRequired_Default,
  AishCallout_Assets_InformationRequired_OboDefault,
  AishCallout_Income_EligibleCdb_Default,
  AishCallout_Income_EligibleCdb_OboDefault,
  AishCallout_Income_EligibleCdb_OboSpousePartner,
  AishCallout_Medical_DoctorSubmitting,
  AishCallout_Medical_DoctorSubmitting_OnBehalf,
  AishCallout_Medical_UploadReport,
  AishCallout_Medical_UploadReport_OnBehalf,
  AishCallout_MySituation_CurrentClientReapplying,
  AishCallout_MySituation_ReapplyBenefit_OnBehalf,
  AishCallout_MySituation_ReceivedBenefitAndStopped_OnBehalf,
  AishCallout_PrescreenPage_ReapplyBenefit,
  AishCallout_PrescreenPage_ReceivedBenefitAndStopped,
  AishCallout_SubmissionBox_Submitted_Default,
  AishCallout_SubmissionBox_Submitted_OboDefault,
  AishCallout_YourRelationship_SigningAuthorityChange,
  AishCallout_YourRelationship_Trustee_Required,
  AishCallout_YourRelationship_TrusteeLegalGuardian_Appointed,
  AishCallout_YourRelationship_TrusteeLegalGuardian_Required,
} from './callout.labels';

export const AishCallout_Income_EligibleCdb_CalloutCollection = {
  value: AishCallout_Income_EligibleCdb_Default,
  default: AishCallout_Income_EligibleCdb_Default,
  spousePartner: null,
  oboDefault: AishCallout_Income_EligibleCdb_OboDefault,
  oboSpousePartner: AishCallout_Income_EligibleCdb_OboSpousePartner,
} as CalloutContentCollection;

export const AishCallout_Medical_DoctorSubmitting_CalloutCollection = {
  default: AishCallout_Medical_DoctorSubmitting,
  oboDefault: AishCallout_Medical_DoctorSubmitting_OnBehalf,
} as CalloutContentCollection;

export const AishCallout_Medical_UploadReport_CalloutCollection = {
  default: AishCallout_Medical_UploadReport,
  oboDefault: AishCallout_Medical_UploadReport_OnBehalf,
} as CalloutContentCollection;

export const AishCallout_Assets_AssetsRequired_CalloutCollection = {
  default: AishCallout_Assets_InformationRequired_Default,
  oboDefault: AishCallout_Assets_InformationRequired_OboDefault,
} as CalloutContentCollection;

//all callouts and variations for income
export const AishCallouts_Income: CalloutCollection = {
  eligibleCbd: AishCallout_Income_EligibleCdb_CalloutCollection,
};

//all callouts and variations for the submission box
export const AishCallouts_SubmissionBox: CalloutCollection = {
  submitted: {
    default: AishCallout_SubmissionBox_Submitted_Default,
    oboDefault: AishCallout_SubmissionBox_Submitted_OboDefault,
  },
};

//all callouts and variations for medical
export const AishCallouts_Medical: CalloutCollection = {
  doctorSubmitting: AishCallout_Medical_DoctorSubmitting_CalloutCollection,
  uploadReport: AishCallout_Medical_UploadReport_CalloutCollection,
};

//all callouts and variations for assets
export const AishCallouts_Assets: CalloutCollection = {
  assetsRequired: AishCallout_Assets_AssetsRequired_CalloutCollection,
};

//all callouts and variations for my situation
export const AishCallouts_MySituation: CalloutCollection = {
  reapplyBenefit: {
    default: AishCallout_PrescreenPage_ReapplyBenefit,
    oboDefault: AishCallout_MySituation_ReapplyBenefit_OnBehalf,
  },
  receivedBenefitStopped: {
    default: AishCallout_PrescreenPage_ReceivedBenefitAndStopped,
    oboDefault: AishCallout_MySituation_ReceivedBenefitAndStopped_OnBehalf,
  },
  currentClientReapplying: { value: AishCallout_MySituation_CurrentClientReapplying },
};

//all callouts and variations for your relationship. these callouts don't have variations, so just pass in value
export const AishCallouts_YourRelationship: CalloutCollection = {
  trusteeGuardianRequired: { value: AishCallout_YourRelationship_TrusteeLegalGuardian_Required },
  trusteeRequired: { value: AishCallout_YourRelationship_Trustee_Required },
  signingAuthorityChange: { value: AishCallout_YourRelationship_SigningAuthorityChange },
  trusteeGuardianAppointed: { value: AishCallout_YourRelationship_TrusteeLegalGuardian_Appointed },
};
